require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-clj-collection-apis-reasonml.json") })
        }
      }, "path---package-clj-collection-apis-reasonml");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-clj-collection-apis-reasonml!./.cache/json/package-clj-collection-apis-reasonml.json
// module id = 856
// module chunks = 231608221292675